import React, { Component } from 'react';
import '../styles/style.css';

class HolidayGift extends Component {
    render(){
        return(
            <section className="holiday-gift-section">
                <p>Get your holiday gifts on time. See when to order <i className="arrow right"></i></p>
            </section>
        )
    }
}

export default HolidayGift;